import styled from "styled-components";

export const Container = styled.div`
width: 40%;
max-width: 415px;
border-right: 1px solid #ddd;
height: 100vh;
`;